import { CardioOrResistance, Exercise } from '../../../entities/exercise/exercise';
import { IExerciseRepository } from '../interfaces/iexercise-repository';

export class DbExerciseRepository implements IExerciseRepository {
  // use any for db, since it is either pouchdb-node or pouchdb
  constructor(private db: any) {
  }

  public async getAll(): Promise<Exercise[]> {
    const results: any = await this.db.allDocs({ include_docs: true });
    const docs: any[] = results
      .rows
      .map((row: any) => row.doc)
      .filter((doc: any) => doc._id !== '0')
      .filter((doc: any) => !!doc.uniqueReferenceNumber);
    const exercises: Exercise[] = docs.map((doc: any): Exercise => {
      const returnObj: Exercise =
        Object.assign(new Exercise('', '', [], false, [CardioOrResistance.Cardio], [], [], []), doc);
      return returnObj;
    });

    return exercises;
  }

  public add(exercise: Exercise): Promise<void> {
    const doc = JSON.parse(JSON.stringify(exercise));
    doc._id = exercise.name;
    return this.db.put(doc);
  }

  public async importJsonString(exercisesAsJsonString: string): Promise<void> {
    const lines = exercisesAsJsonString.split(/\r\n|\r|\n/);
    const exercises: Exercise[] = JSON.parse(exercisesAsJsonString);
    if (lines.length !== exercises.length) {
      // throw new Error(`Expected to import ${lines.length} exercises but only parsed ${exercises.length}`);
    }
    const docs = JSON.parse(JSON.stringify(exercises));
    return this.db.bulkDocs(docs);
  }

  public async get(id: string): Promise<Exercise | undefined> {
    try {
      const exercise = await this.db.get(id);
      return Object.assign(new Exercise('', '', [], false, [CardioOrResistance.Cardio], [], [], []), exercise);
    } catch (err) {
      if (err.status === 404) {
        return undefined;
      } else {
        throw err;
      }
    }
  }
}
